import React, { useState, useMemo } from 'react';
import { Button, Form, Select, Input, Table, DatePicker } from 'antd';
import TextArea from 'rc-textarea';

import countryList from 'react-select-country-list'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { DeleteOutlined } from '@ant-design/icons';
const { Option } = Select;

const Invoice = () => {
    const [count, setCount] = useState(3);
    const [dataSource, setDataSource] = useState([]);
    const [form] = Form.useForm();
    const [value, setValue] = useState('')
    const [valuePhoneNumber, setValuePhoneNumber] = useState()

    const options = useMemo(() => countryList().getData(), [])
    const changeHandler = value => {
        setValue(value)
    }
    // const onFinish = (values) => {
    //     console.log('Success:', values);
    // };
    const onFinish = async (values) => {
        const filteredItems = dataSource.map(({ key, ...rest }) => rest);

        const finalData = {
            ...values,
            items: filteredItems,
        };

        console.log("Final Data:", finalData);

        try {
            const response = await fetch("https://chatbot.liqteq.com/api/invoice_initialized", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(finalData),
            });

            if (response.ok) {
                alert("Invoice Submitted Successfully!");
                form.resetFields();
                setDataSource([]);
                setCount(1);
            } else {
                alert("Failed to Submit Invoice");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Something went wrong!");
        }
    };


    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const untaxedAmount = dataSource.reduce((sum, row) => sum + row.quantity * row.price, 0);
    const total = dataSource.reduce((sum, row) => sum + row.subTotal, 0);


    const handleInputChange = (key, dataIndex, value) => {
        const newData = dataSource.map((item) => {
            if (item.key === key) {
                const updatedItem = { ...item, [dataIndex]: value };
                updatedItem.subTotal = updatedItem.quantity * updatedItem.price + Number(updatedItem.taxes);
                return updatedItem;
            }
            return item;
        });
        setDataSource(newData);
    };
    const handleAddRow = () => {
        const newRow = {
            key: count.toString(),
            product: '',
            quantity: 1,
            price: 0,
            taxes: 0,
            subTotal: 0,
        };
        setDataSource([...dataSource, newRow]);
        setCount(count + 1);
    };
    const handleDeleteRow = (key) => {
        const newData = dataSource.filter((item) => item.key !== key);
        setDataSource(newData);
    };

    const columns = [

        {
            title: 'Product',
            dataIndex: 'product',
            key: 'product',
            render: (text, record) => (
                <Input
                    value={text}
                    onChange={(e) => handleInputChange(record.key, 'product', e.target.value)}
                />
            ),
        },

        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (text, record) => (
                <Input
                    type="number"
                    value={text}
                    onChange={(e) => handleInputChange(record.key, 'quantity', e.target.value)}
                />
            ),
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
            render: (text, record) => (
                <Input
                    type="number"
                    value={text}
                    onChange={(e) => handleInputChange(record.key, 'price', e.target.value)}
                />
            ),
        },
        {
            title: 'Taxes',
            dataIndex: 'taxes',
            key: 'taxes',
            render: (text, record) => (
                <Input
                    type="number"
                    value={text}
                    onChange={(e) => handleInputChange(record.key, 'taxes', e.target.value)}
                />
            ),
        },
        {
            title: 'Sub Total',
            dataIndex: 'subTotal',
            key: 'subTotal',
            render: (text, record) => (
                <Input
                    type="number"
                    value={record.subTotal}
                    disabled
                />
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => (
                <Button onClick={() => handleDeleteRow(record.key)} type="danger">
<DeleteOutlined  style={{color:'red'}}/>                </Button>
            ),
        },
    ];
    return (
        <div style={{ margin: '10px' }}>
            <h2 style={{ fontWeight: "bold", fontSize: '22px', marginBottom: '10px' }}>Draft Invoice</h2>
            <div>
                <Form
                    name="basic"
                    layout="vertical"
                    initialValues={{ remember: false }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}

                    autoComplete="off"
                    labelAlign='left'
                    className='FormFont'
                >
                    <div style={{ display: 'flex', gap: '20px', marginBottom: '-5px' }}>

                        <Form.Item
                            name="client_name"
                            label="Customer"
                            required={false}

                            rules={[{ required: true, message: 'Please select Customer' }]}
                            style={{ flex: 1 }}
                        >
                            <Input />

                        </Form.Item>
                        <Form.Item
                            name="invoiceDate"
                            label="Invoice Date"
                            required={false}

                            rules={[{ required: true, message: 'Please select Invoice Date' }]}
                            style={{ flex: 1 }}
                        >
                            <DatePicker style={{ width: '100%' }} />
                        </Form.Item>
                        <Form.Item
                            name="client_email"
                            label="Email Address"
                            required={false}

                            rules={[{ required: true, message: 'Please enter Email Address' }]}
                            style={{ flex: 1 }}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="client_country"
                            label="Country"
                            required={false}

                            rules={[{ required: true, message: 'Please enter Country' }]}
                            style={{ flex: 1 }}
                        >
                            <Select options={options} value={value} onChange={changeHandler} />

                        </Form.Item>
                    </div>

                    {/* Row 2 */}
                    <div style={{ display: 'flex', gap: '20px', marginBottom: '-5px' }}>

                        <Form.Item
                            name="client_address"
                            label="Delivery Address"
                            required={false}

                            rules={[{ required: true, message: 'Please enter Delivery Address' }]}
                            style={{ flex: 1 }}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="client_city"
                            label="City"
                            required={false}

                            rules={[{ required: true, message: 'Please enter City' }]}
                            style={{ flex: 1 }}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="client_state"
                            label="State"
                            required={false}

                            rules={[{ required: true, message: 'Please enter State' }]}
                            style={{ flex: 1 }}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="client_zip"
                            label="Zip Code"
                            required={false}

                            rules={[{ required: true, message: 'Please enter Zip Code' }]}
                            style={{ flex: 1 }}
                        >
                            <Input />
                        </Form.Item>
                    </div>


                    <div style={{ display: 'flex', gap: '20px', marginBottom: '-5px' }}>
                       
                        <Form.Item
                            name="client_phone"
                            label="Phone Number"
                            required={false}

                            rules={[{ required: true, message: 'Please enter Phone Number' }]}
                            style={{ flex: 1 }}
                        >
                        
                            <PhoneInput
                                country="US"
                                value={valuePhoneNumber}
                                onChange={setValuePhoneNumber}
                            />


                        </Form.Item>
                        <Form.Item
                            name="currency"
                            required={false}

                            label="Currency"
                            rules={[{ required: true, message: 'Please select Currency' }]}
                            style={{ flex: 1 }}
                        >
                            <Select >
                                <Select.Option value="usd">USD</Select.Option>
                                <Select.Option value="pkr">PKR</Select.Option>


                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="reference"
                            label="Reference"
                            required={false}

                            rules={[{ required: true, message: 'Please enter Reference' }]}
                            style={{ flex: 1 }}
                        >
                            <Select >
                                <Select.Option value="PO-2025-001">A purchase order reference number</Select.Option>
                                <Select.Option value="Contract-XYZ-789">A contract identifier</Select.Option>
                                <Select.Option value="INV-REF-9876">Custom invoice tracking reference</Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="payment_terms"
                            label="Payment Terms"
                            required={false}

                            rules={[{ required: true, message: 'Please enter Payment Terms' }]}
                            style={{ flex: 1 }}
                        >
                            <Select >
                                <Select.Option value="DUE_ON_RECEIPT">Payment is due immediately upon receiving the invoice.</Select.Option>
                                <Select.Option value="NET_15">Payment is due within 15 days from the invoice date.</Select.Option>
                                <Select.Option value="NET_30">Payment is due within 30 days from the invoice date.</Select.Option>
                                <Select.Option value="NET_60">Payment is due within 60 days from the invoice date.</Select.Option>
                                <Select.Option value="DUNET_90">Payment is due within 90 days from the invoice date.</Select.Option>


                            </Select>
                        </Form.Item>
                    </div>

                    {/* Row 5 */}
                    <div style={{ display: 'flex', gap: '20px', }}>


                      
                        <Form.Item
                            name="note"
                            label="Note"
                            required={false}

                            rules={[{ required: true, message: 'Please enter Note' }]}
                            style={{ flex: 2, fontSize: '8px' }}
                        >
                            <TextArea rows={3} style={{ width: '100%', border: '1px solid lightgray', borderRadius: '5px', padding: "3px" }} placeholder="" />
                        </Form.Item>

                    </div>

                    <div>
                        <Table
                            dataSource={dataSource}
                            columns={columns}
                            bordered
                            pagination={false}
                            style={{ marginBottom: '20px' }}
                            components={{
                                header: {
                                    cell: ({ children, ...restProps }) => (
                                        <th {...restProps} style={{ backgroundColor: '#172554', color: 'white', borderColor: '#172554' }}>
                                            {children}
                                        </th>
                                    ),
                                },
                            }}
                            footer={() => (
                                <Button type="dashed" onClick={handleAddRow} style={{ width: '100%' }}>
                                    + Add Row
                                </Button>
                            )}
                        />
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginTop: '10px',
                        gap: '20px',
                        fontSize: '14px',
                        fontWeight: '500'

                    }}>

                        <div>
                            <span>untaxed Amount: </span>
                            <Input
                                style={{ width: '120px' }}
                                value={untaxedAmount}
                                disabled
                            />
                        </div>
                        <div>
                            <span>Total: </span>
                            <Input
                                style={{ width: '120px' }}
                                value={total}
                                disabled
                            />
                        </div>
                        <div style={{ width: '15%' }}>
                            <Form.Item>
                                <Button style={{ background: '#172554', color: 'white', width: "100%" }} htmlType="submit">
                                    Submit
                                </Button>
                            </Form.Item>
                        </div>

                    </div>

                </Form>
            </div>
        </div>
    );
};

export default Invoice;
